import { Caption, css, Mode, styled } from 'canoe';

export const FieldsEditorWrapper = styled.div<{
  isPopover?: boolean;
}>``;

export const FieldEditorContainer = styled.div<{
  isPopover?: boolean;
  mode?: Mode;
  isActive: boolean;
  testId?: string;
}>`
  ${({ theme, isPopover, mode, isActive }) => css`
    ${isPopover &&
    isActive &&
    css`
      &:not(:last-child) {
        margin-bottom: calc(${theme.spaces.xs} + 2px);
      }
    `}
    ${!isPopover &&
    css`
      margin-top: ${theme.spaces.xxs};

      & > div:first-of-type {
        margin-bottom: 0;
      }

      & > div:nth-of-type(2) > div {
        margin: 0;
      }

      & > div:nth-of-type(2) > button {
        border-top-left-radius: 0;
        border-top-right-radius: 0;
        box-shadow: none;
        background-color: ${isPopover ? theme.colors.White : theme.colors.GlitterGrayL30};
        border-color: ${theme.colors.GlitterGray};

        &:focus,
        &:hover {
          box-shadow: none;
          border-color: ${theme.colors.GlitterGrayD20};
        }
      }
    `}
    label {
      color: ${theme.colors.OnyxGrayL20};
      ${mode === 'Dark' &&
      css`
        color: ${theme.colors.GlitterGray};
      `}
    }
  `}
`;

export const DynamicSettingsRow = styled.div`
  ${({ theme }) => css`
    display: flex;
    gap: ${theme.spaces.xs};
    align-items: center;
  `}
`;

export const CollectionLocation = styled.span`
  flex-shrink: 0;
`;

export const CollectionName = styled.span`
  ${({ theme }) => css`
    font-weight: ${theme.fontWeights.bold};
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    flex-shrink: 1;
  `}
`;

const CheckboxLabelBase = styled(Caption)<{ mode: Mode; htmlFor?: string }>`
  ${({ theme, mode }) => css`
    height: 100%;
    margin: 0;
    display: flex;
    align-items: center;
    line-height: normal;

    ${mode === 'Dark' &&
    css`
      color: ${theme.colors.GlitterGray};
    `}
  `}
`;

export const CheckboxLabelToolbar = styled(CheckboxLabelBase)`
  ${({ theme }) => css`
    margin-left: ${theme.spaces.xs};
    max-width: calc(100% - ${theme.spaces.xs} - 16px);
  `}
`;

export const CheckboxLabelToolbox = styled(CheckboxLabelBase)``;
